// export const domain = "http://localhost:4010/api";
export const domain = "https://www.kolaydiyetisyen.com/api"